import { NoContent } from '@dynamika-shared/ui/NoContent/NoContent';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { useEffect, useState } from 'react';
import { OpenQueryDrawer } from 'src/pages/QC/QCSubjectQueries/components/OpenQueryDrawer/OpenQueryDrawer';
import { QueryCard } from 'src/pages/QC/QCSubjectQueries/components/QueryCard/QueryCard';
import { useQCQueryHandlers } from '@components/Queries/useQCQueryHandlers';
import { useQCQueriesSlice } from '@restore/qcQueries/qcQueries.slice';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useQCTaskSlice } from '@restore/QCTask/QCTask.slice';

const QcSubjectQueries = () => {
  const [openQuery, setOpenQuery] = useState<boolean>(false);
  const [
    loading,
    data,
    fetchQCQueries,
    setFilters,
    currentQueryUpdating,
    updateCurrentQuery,
  ] = useQCQueriesSlice((state, actions) => [
    state.loading,
    state.data,
    actions.fetchQCQueries,
    actions.setFilters,
    state.currentQueryUpdating,
    actions.updateCurrentQuery,
  ]);
  const ctId = useClinicalTrialContextSlice(
    state => state.data?.configuration?.id
  );

  const queries = data?.content ?? [];
  const visitId = useQCTaskSlice(s => s.data?.visitId);
  const { handlers } = useQCQueryHandlers({
    ctId: ctId!,
    updating: currentQueryUpdating,
    updateCurrentQuery,
  });

  useEffect(() => {
    if (!ctId) return;
    if (visitId) {
      setFilters({ filterQuery: 'visitId', filterValue: visitId });
    }
    fetchQCQueries(ctId);
  }, [ctId, visitId]);

  return (
    <div className='w-full'>
      {data?.content?.length ? (
        <div className='w-full'>
          <div className='flex items-center justify-between w-full bg-white py-2 pt-0'>
            <h2 className='text-1824 ms-0.5'>Queries List</h2>
            <Button
              className='!border-blackOlive !bg-blackOlive text-white hover:!border-dodgerBlue  hover:!bg-dodgerBlue px-2'
              iconType='plus'
              onClick={() => setOpenQuery(true)}
            >
              Open query
            </Button>
          </div>
          {!loading && (
            <div className='-me-2'>
              <div className='w-full overflow-y-auto h-[calc(100vh-550px)] pe-2'>
                {queries.map(query => (
                  <QueryCard
                    key={query.id}
                    query={query}
                    selectedRole={handlers.selectedRole}
                    onSubmit={handlers.handleListQuerySubmit}
                    updating={handlers.updating}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <NoContent
          iconName={'puzzle'}
          title={
            <span className='text-spanishGray'>
              No <b className='text-chineseBlack'>Queries</b> here yet! <br />
              If you have any issues with upload data you <br />
              always can open a query.
            </span>
          }
        >
          <Button
            className='w-[14.4rem] border-none !bg-blackOlive  !text-1420 text-white hover:!bg-dodgerBlue'
            onClick={() => setOpenQuery(true)}
          >
            Open Query
          </Button>
        </NoContent>
      )}
      {openQuery && <OpenQueryDrawer onClose={() => setOpenQuery(false)} />}
    </div>
  );
};
export default QcSubjectQueries;
